import { MeanAgeModel } from '../../../../types/indicators.interfaces';
import {
  XAxis,
  XAxisLabel,
  HorizontalBar,
  YAxisLabel,
  YAxis,
  BarGraph,
  BarGroup,
  BarValue,
} from '../zonePopulation.styles';

export const AgeDistributionGraph = (data: MeanAgeModel) => {
  const ranges = [...(data.ranges ?? [])].reverse();
  const maxPercentage = Math.max(
    ...ranges.map((item) => (item.value ? Number(item?.value?.toFixed(2)) : 0))
  );
  return (
    <BarGraph>
      <XAxis>
        {generatePercentageProgression(maxPercentage).map((label, index) => (
          <XAxisLabel key={index}>{label}%</XAxisLabel>
        ))}
      </XAxis>
      <YAxis>
        {ranges.map((item, index) => (
          <YAxisLabel key={index}>
            <div style={{ width: '15%', whiteSpace: 'nowrap' }}>
              {item.range}
            </div>
            <BarGroup>
              {item.value && (
                <>
                  <HorizontalBar
                    width={`${(item.value / (maxPercentage + 5)) * 100}%`}
                    backgroundcolor="#512b58"
                  />
                  <BarValue>{Number(item.value).toFixed(1)}%</BarValue>
                </>
              )}
            </BarGroup>
          </YAxisLabel>
        ))}
      </YAxis>
    </BarGraph>
  );
};

// Generate X-axis labels as percentages up to the maximum percentage found
function generatePercentageProgression(maxPercentage: number) {
  const steps = 4;
  const interval = (maxPercentage + 3) / steps;

  const progression = [];
  for (let i = 0; i <= steps; i++) {
    progression.push(Math.ceil(interval * i));
  }

  return progression;
}
